import { render, staticRenderFns } from "./topSearchForm.vue?vue&type=template&id=508bb9c4&scoped=true&"
import script from "./topSearchForm.vue?vue&type=script&lang=js&"
export * from "./topSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./topSearchForm.vue?vue&type=style&index=0&id=508bb9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508bb9c4",
  null
  
)

export default component.exports